@let hasShiftUpdatePermission =
  can(RoleAction.Update, RolePermissionSubject.Shift);
@let hasWorkTimeManagementUpdatePermission =
  can(RoleAction.Update, RolePermissionSubject.WorkTimeManagement);
@let hasPayrollUpdatePermission =
  can(RoleAction.Update, RolePermissionSubject.Payroll);
@let forbiddenMessage = 'general.forbidden_action' | translate;
@let warningMessage =
  'page.employees.working-times-shifts.accept-warning' | translate;
@let hasClientReadPermission =
  can(RoleAction.Read, RolePermissionSubject.Client);
@let hasBillingFeaturePlan = !!(FeatureName.Billing | featurePure | async);
@let approvedTimeReportAttachmentsFeatureFlag =
  'approved-time-report-attachments' | featureFlagPure | async;
@let hasShiftAttachmentsReadPermission =
  can(RoleAction.Read, RolePermissionSubject.ShiftAttachment);
<button
  class="action-btn"
  nz-button
  nz-dropdown
  [nzDropdownMenu]="action"
  [nzTrigger]="'click'"
  [disabled]="!haveSelectedRows"
  nz-tooltip
  [nzTooltipTitle]="!haveSelectedRows ? warningMessage : ''"
  data-test-id="wilson-work-time-management-actions:actions-button"
>
  <span>{{ 'general.actions' | translate }}</span>
  <i nz-icon nzType="down"></i>
</button>

<nz-dropdown-menu #action="nzDropdownMenu">
  <ul nz-menu>
    @let hasUpdatePermission =
      hasShiftUpdatePermission && hasWorkTimeManagementUpdatePermission;
    @let isSendBackToAssigneeButtonDisabled =
      !hasUpdatePermission ||
      !haveSelectedRows ||
      !selectedRowsCanBeAcceptedOrSentBack;
    @let isFillWithPlannedTimesButtonDisabled =
      !hasUpdatePermission ||
      !haveSelectedRows ||
      !selectedRowsCanBeTimeAdjusted;
    @let isAddPayrollTransactionsButtonDisabled =
      !hasPayrollUpdatePermission ||
      !haveSelectedRows ||
      !selectedRowsCanBeAddPayrollTransactions;

    <li
      nz-menu-item
      [nzDisabled]="isSendBackToAssigneeButtonDisabled"
      (click)="
        !isSendBackToAssigneeButtonDisabled &&
          updateSelectedShifts.emit(ShiftState.Reopened)
      "
      nz-tooltip
      [nzTooltipTitle]="!hasUpdatePermission ? forbiddenMessage : ''"
      data-test-id="wilson-work-time-management-actions:for-processing-button"
    >
      {{ 'page.work_time_management.for_processing' | translate }}
      @if (haveSelectedRows && selectedRowsCanBeAcceptedOrSentBack) {
        <span class="selectedItemsCount">{{
          ' (' + selectedRowsCount + ')'
        }}</span>
      }
    </li>
    @if ('azm-is-times-to-planned-times' | featureFlagPure | async) {
      <li
        nz-menu-item
        [nzDisabled]="isFillWithPlannedTimesButtonDisabled"
        (click)="
          !isFillWithPlannedTimesButtonDisabled &&
            updateSelectedShiftsAdjustTime()
        "
        nz-tooltip
        [nzTooltipTitle]="!hasUpdatePermission ? forbiddenMessage : ''"
        data-test-id="wilson-work-time-management-actions:fill-with-planned-times-button"
      >
        {{ 'page.work_time_management.fill_with_planned_times' | translate }}
        @if (haveSelectedRows && selectedRowsCanBeTimeAdjusted) {
          <span class="selectedItemsCount">{{
            ' (' + selectedRowsCount + ')'
          }}</span>
        }
      </li>
    }
    @if ('portal-manual-payroll-transactions' | featureFlagPure | async) {
      <li
        nz-menu-item
        [nzDisabled]="isAddPayrollTransactionsButtonDisabled"
        (click)="
          !isAddPayrollTransactionsButtonDisabled &&
            openManualTransactionModal()
        "
        nz-tooltip
        [nzTooltipTitle]="!hasPayrollUpdatePermission ? forbiddenMessage : ''"
        data-test-id="wilson-work-time-management-actions:add-payroll-transactions"
      >
        {{ 'work_time_management.drawer.add_payroll_transactions' | translate }}
        @if (haveSelectedRows && selectedRowsCanBeAddPayrollTransactions) {
          <span class="selectedItemsCount">{{
            ' (' + selectedRowsCount + ')'
          }}</span>
        }
      </li>
    }
    @if (approvedTimeReportAttachmentsFeatureFlag) {
      @let isDisabled =
        !isEveryShiftSubmittedSignal() ||
        selectedRowsCount > MAX_SELECTABLE_SHIFTS;
      <li
        class="fw-normal"
        nz-menu-item
        data-test-id="wilson-work-time-management-actions:action-export-shift-report"
        (click)="
          !isDisabled &&
            handleBulkShiftExport({
              hasBillingFeaturePlan: hasBillingFeaturePlan,
              hasClientReadPermission: hasClientReadPermission,
            })
        "
        [nzDisabled]="isDisabled"
        nz-tooltip
        [nzTooltipTitle]="
          selectedRowsCount
            | exportShiftReportTranslationPipe: isEveryShiftSubmittedSignal()
        "
      >
        {{ 'shift.page.export_shift.reports' | translate }}
      </li>
    }
    @if (hasShiftAttachmentsReadPermission) {
      @let isDisabled =
        selectedRowsCount > MAX_SELECTABLE_SHIFTS_FOR_ADDING_ATTACHMENTS;
      @let disabledButtonTranslation =
        isDisabled
          ? ('shift.page.add_attachments.button.disabled' | translate)
          : '';

      <li
        nz-menu-item
        [nzDisabled]="isDisabled"
        nz-tooltip
        [nzTooltipTitle]="disabledButtonTranslation"
        (click)="!isDisabled && openAttachmentsModal()"
      >
        {{ 'general.add_attachments' | translate }}
      </li>
      @if (approvedTimeReportAttachmentsFeatureFlag) {
        <li
          nz-menu-item
          [nzDisabled]="isDisabled"
          nz-tooltip
          [nzTooltipTitle]="disabledButtonTranslation"
          (click)="!isDisabled && openReportsModal()"
        >
          {{ 'general.add_shift_report' | translate }}
        </li>
      }
    }
  </ul>
</nz-dropdown-menu>
